import styled from 'styled-components';
import {Row} from '../../../../../../stories/components/hotels/common/Layouts/Layouts';

export const PayModePersuasionContainer = styled.div(
  props => `
  padding: ${props.theme.spacing.base} 0 0 0;
  display: flex;
  align-items: center;
`,
);

export const PayModePersuasionTextsContainer = styled.div(
  props => `
  padding: 0 0 0 ${props.theme.spacing.small.s5};
`,
);

export const PayModePersuasionTextContainer = styled.span(
  props => `
  color: ${props.theme.colors.green.base};
`,
);
export const PayModePersuasionSubTextContainer = styled.span(
  props => `
    font-size: ${props.theme.font.base};
  `
);

export const TaxesTextStyled = styled(Row)(
  props => `
  font-size: ${props.theme.font.small.font10};
  color: ${props.theme.colors.green.base};
  
`,
);

export const PayAtHotelTaxesText = styled.span(
  props => `
  padding: 0 ${props.theme.spacing.small.s2} 0 0;
`,
);
